import React, { useState } from 'react';

const OrganizationPage =() =>{

    return(
        <div style={{display:'flex',flexDirection:'row',marginTop:'15px'}}>
            <div className='col-12 col-md-6' style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                <h4>Organization List</h4>
                <div>
                    <p style={{marginBottom:'0px'}}> Datalake Solutions</p>
                    <p style={{marginBottom:'0px'}}>YBDLS</p>
                    <p style={{marginBottom:'0px'}}>YourBuddy</p>
                </div>
            </div>
            <div className='col-12 col-md-6' style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
                <h4>Users List</h4>
                <div>
                    <p style={{marginBottom:'0px'}}> Datalake Solutions</p>
                    <p style={{marginBottom:'0px'}}>YBDLS</p>
                    <p style={{marginBottom:'0px'}}>YourBuddy</p>
                </div>
            </div>
        </div>

    );

}
export default OrganizationPage